import UiRouterFade from './fade'

export default {
  UiRouterFade
}



// WEBPACK FOOTER //
// ./src/components/router/index.js